import { type ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { useCopilotAccess } from '../hooks'

/**
 * Route guard: only renders children (the copilot page) for users the feature is enabled for.
 * Everyone else is redirected to the dashboard, so a direct /copilot URL reveals nothing.
 */
export function RequireCopilot({ children }: { children: ReactNode }) {
  const { orgId } = useParams()
  const access = useCopilotAccess()

  if (access.isLoading) return null
  if (access.data?.enabled !== true) {
    return <Navigate to={orgId ? `/o/${orgId}/dashboard` : '/'} replace />
  }
  return <>{children}</>
}
